import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AvatarModule } from 'primeng/avatar';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { Store } from '@ngxs/store';
import { UserSelectors } from '../../../states/user/user-selector';
import { UserStateModel } from '../../../states/user/user-state-model';
import { Router, RouterModule } from '@angular/router';
import { UserProfileStatus } from '../../../models/account/userProfileStatus';
import { CompleteProfileService } from '../../../services/account/complete-profile.service';
import { NgxGaugeModule } from 'ngx-gauge';
import { ChatDialogComponent } from './chat-dialog/chat-dialog.component';

@Component({
  selector: 'app-ask-me-anything',
  standalone: true,
  imports: [
    FormsModule,
    AvatarModule,
    InputTextModule,
    CheckboxModule,
    InputIconModule,
    NgxGaugeModule,
    IconFieldModule,
    ButtonModule,
    RouterModule,
    ChatDialogComponent
  ],
  templateUrl: './ask-me-anything.component.html',
  styleUrls: ['./ask-me-anything.component.scss']
})
export class AskMeAnythingComponent implements OnInit {
  // Component state variables
  pizza: string[] = [];
  profileStatus: UserProfileStatus | undefined;
  user: UserStateModel | undefined;

  // Gauge configurations
  gaugeType: any = 'arch';
  gaugeValue = 0;
  gaugeLabel = 'Profile Status';
  gaugeAppendText = '%';

  // Markers for visualization
  markers: { [key: string]: any } = {};

  constructor(
    private store: Store,
    private router: Router,
    private completeProfileService: CompleteProfileService
  ) { }

  ngOnInit(): void {
    this.getUser();
    this.setMarkers();
  }

  // Correctly sets up the markers
  setMarkers() {
    for (let i = 10; i <= 100; i += 10) {
      this.markers[i] = {
        color: '#000000', // Black color for all
        type: 'line',     // Line type for all
        size: 4,          // Fixed size
        label: i.toString(), // Label with incremental values
        font: '12px Arial'   // Consistent font style
      };
    }
  }

  // Fetch user details from the store
  getUser() {
    this.store.select(UserSelectors.getUser).subscribe({
      next: (response) => {
        // Only proceed if user has a valid ID
        if (response && response.id) {
          this.user = response;
          this.getProfileStatus();
        }
      },
      error: (error) => {
        console.warn('Error fetching user:', error);
      }
    });
  }

  // Fetch the user's profile status
  getProfileStatus() {
    this.completeProfileService.getProfileStatus(this.user!.id).subscribe({
      next: (response) => {
        this.profileStatus = response;
        this.gaugeValue = Number(response.statusPercentage)
      },
      error: (err) => {
        console.warn('Error while receiving profile status:', err);
      }
    });
  }

  // Navigates to the complete profile page
  completeProfile() {
    this.router.navigate(['portal', 'application-form']);
  }

  // Opens the chat dialog
  openChatDialog() {
    // This will be handled by the chat dialog component
  }
}
